var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureSub1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164159",
    transform: "translate(-1152 -6041)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9444",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1152 6041)",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 27.8a1.316 1.316 0 0 1-1-.425 1.382 1.382 0 0 1-.4-.975 1.367 1.367 0 0 1 1.4-1.4 1.382 1.382 0 0 1 .975.4 1.261 1.261 0 0 1 .425.95 1.4 1.4 0 0 1-.425 1.025 1.341 1.341 0 0 1-.975.425zm8.25 0a1.454 1.454 0 0 1-1.4-1.4 1.316 1.316 0 0 1 .425-1 1.388 1.388 0 0 1 1.95 0 1.316 1.316 0 0 1 .425 1 1.454 1.454 0 0 1-1.4 1.4zm8.15 0a1.454 1.454 0 0 1-1.4-1.4 1.316 1.316 0 0 1 .425-1 1.388 1.388 0 0 1 1.95 0 1.316 1.316 0 0 1 .425 1 1.454 1.454 0 0 1-1.4 1.4zM11.3 41.4a2.648 2.648 0 0 1-2.7-2.7V13a2.648 2.648 0 0 1 2.7-2.7h4.4V6h1.35v4.3h14.1V6h1.2v4.3h4.35a2.648 2.648 0 0 1 2.7 2.7v25.7a2.648 2.648 0 0 1-2.7 2.7zm0-1.1h25.4a1.721 1.721 0 0 0 1.6-1.6V21.45H9.7V38.7a1.721 1.721 0 0 0 1.6 1.6zM9.7 20.35h28.6V13a1.721 1.721 0 0 0-1.6-1.6H11.3A1.721 1.721 0 0 0 9.7 13zm0 0z",
    transform: "translate(1172.4 6061)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSub1);
export default __webpack_public_path__ + "static/media/feature-sub-1.ddd7697d63c3de99530e3144a38588c9.svg";
export { ForwardRef as ReactComponent };